export default "__VITE_ASSET__DD8Jg2FC__"